import {
    SETTINGS_ACTION_WORKSPACE_ACCESS_REQUESTS_ERROR,
    SETTINGS_ACTION_WORKSPACE_ACCESS_REQUESTS_SUCCESS,
    SETTINGS_ACTION_WORKSPACE_ACCESS_REQUESTS_REQUEST,
} from "../../Types/user/Types";

const initialState = {
    error: "",
    settings_action_workspace_access_requests_data: "",
    loader: false,
};
const SettingsActionWorkspaceAccessRequestsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SETTINGS_ACTION_WORKSPACE_ACCESS_REQUESTS_SUCCESS:
            return {
                ...initialState.settings_action_workspace_access_requests_data,
                error: "",
                settings_action_workspace_access_requests_data: action.payload,
                loader: false,
            };
        case SETTINGS_ACTION_WORKSPACE_ACCESS_REQUESTS_ERROR:
            return {
                ...initialState.settings_action_workspace_access_requests_data,
                error: action.error,
                settings_action_workspace_access_requests_data: "",
                loader: false,
            };
        case SETTINGS_ACTION_WORKSPACE_ACCESS_REQUESTS_REQUEST:
            return {
                ...initialState.settings_action_workspace_access_requests_data,
                error: null,
                settings_action_workspace_access_requests_data: "",
                loader: true,
            };
        default:
            return state;
    }
};
export default SettingsActionWorkspaceAccessRequestsReducer;